/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     动态路由视图映射
  +--------------------------------------------------------------------------------------
*/

// // 自动导入 @/views 文件夹下所有后缀为 .vue 的文件
const dynamicViewsMap = {};
const re = /([^/]*)\.vue$/;

const dbViews = require.context("@/views/db/", false, /\.vue$/);
const pmViews = require.context("@/views/pm/", false, /\.vue$/);
const mesViews = require.context("@/views/mes/", false, /\.vue$/);
const qcViews = require.context("@/views/qc/", false, /\.vue$/);
const emViews = require.context("@/views/em/", false, /\.vue$/);
const mmViews = require.context("@/views/mm/", false, /\.vue$/);
const ppViews = require.context("@/views/pp/", false, /\.vue$/);
const kpiViews = require.context("@/views/kpi/", false, /\.vue$/);
const sysViews = require.context("@/views/sys/", false, /\.vue$/);

dbViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/db/" + key + ".vue");
});
pmViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/pm/" + key + ".vue");
});
mesViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/mes/" + key + ".vue");
});
qcViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/qc/" + key + ".vue");
});
emViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/em/" + key + ".vue");
});
mmViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/mm/" + key + ".vue");
});
ppViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/pp/" + key + ".vue");
});
kpiViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/kpi/" + key + ".vue");
});
sysViews.keys().forEach(function(item) {
  const key = item.match(re)[1];
  dynamicViewsMap[key] = () => import("@/views/sys/" + key + ".vue");
});

export default dynamicViewsMap;
